const HousePairIcon = ({ className }: { className: string }) => {
  return (
    <svg
      aria-hidden='true'
      className={className}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5 22a2 2 0 0 1-2-2V8l5-4 1 .5'
        stroke='#1A1A1A'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='m7 9 7-5 7 5v11a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V9Z'
        stroke='#1A1A1A'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11 22v-8h6v8'
        stroke='#1A1A1A'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default HousePairIcon;
